import { Outlet, Navigate } from 'react-router-dom'
import { useSelector } from 'react-redux'

const PublicRoute = () => {
  const isLogged = useSelector((state) => state.isLogged)
  const ACCtoken = useSelector((state) => state.ACCtoken)

  // If user is already logged in, redirect to dashboard
  if (isLogged && ACCtoken) {
    return <Navigate to="/dashboard" replace />
  }

  // Otherwise, render the public route
  return <Outlet />
}

export default PublicRoute